import Cookies from "js-cookie";
import React, {useState} from 'react';
import LogoutConfirmationModal from "../modals/LogoutConfirmationModal";

const Header = () => {
    const username = Cookies.get('username')
    const [showLogoutConfirmation, setShowLogoutConfirmation] = useState(false)
    return <>
        <div className='flex justify-around p-3 md:hidden'>
            <img className='w-[25%]' src='/images/logo.png'/>
        </div>
        <div className='flex md:hidden justify-between items-center'>
            <div className={`flex`}>
                <div className='flex flex-col justify-around ms-2'>
                    <p className='font-bold text-[16px] text-orange'>{username}</p>
                </div>
            </div>
            <img onClick={() => setShowLogoutConfirmation(true)} className='w-[32px] h-[32px] mx-2 cursor-pointer'
                 src='/icons/power.png'/>
        </div>
        <div className='justify-around hidden md:flex mb-10'>
            <img className='w-[7%]' src='/images/logo.png'/>
            <div className='flex basis-2/6 justify-end items-center'>
                <img className='w-[64px] h-[64px]' src='/icons/user-desktop-logo.png'/>
                <div className='flex flex-col justify-center ms-2'>
                    <p className='font-bold text-[16px] text-white'>{username}</p>
                </div>
                <img onClick={() => setShowLogoutConfirmation(true)} className='w-[32px] h-[32px] mx-2 cursor-pointer'
                     src='/icons/power.png'/>
            </div>
        </div>
        <LogoutConfirmationModal handleSetOpen={(value) => setShowLogoutConfirmation(value)}
                                 open={showLogoutConfirmation}/>
    </>
}

export default Header;